<template>
    <BaseModal :close="setCookies" :is-open="isOpen">
        <div
            class="bg-white rounded-t-xl lg:rounded-md w-screen md:w-[78vw] xl:w-[45vw] lg:h-auto px-6 pt-9 pb-8 lg:px-16 lg:py-14"
        >
            <div :id="carouselId" class="swiper">
                <div class="swiper-wrapper">
                    <div v-for="slide in steps" :key="`onboarding-step-${slide.id}`" class="swiper-slide">
                        <div class="flex flex-col text-center justify-center items-center">
                            <span class="block font-Inter-Bold text-[1.5rem] lg:text-2xl mb-3">{{ slide.title }}</span>
                            <span class="block mb-5 text-sm lg:text-[0.9375rem] leading-5 lg:leading-5 lg:w-10/12">{{
                                slide.description
                            }}</span>
                            <div class="w-full lg:w-10/12 h-auto">
                                <div class="aspect-w-4 aspect-h-3 w-full h-full">
                                    <img
                                        :src="
                                            require(`~/assets/images/editor_onboarding_illustrations/${slide.illustration}`)
                                        "
                                        :alt="slide.title"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="swiper-pagination swiper-pagination--black relative mt-2 md:mt-4 left-0 bottom-0 min-h-[1.5rem]"
                    @click="setSlide"
                ></div>
                <div class="w-full text-center" @click="nextSlide">
                    <button
                        class="rounded-full text-base bg-yellow-100 hover:bg-yellow-200 text-black mt-1 mx-auto w-full md:w-7/12 transition font-Inter-Bold text-center py-3 px-7 lg:xpx-8 flex items-center leading-none justify-center group"
                    >
                        {{ currentStep >= startIndex ? $t('editor.instructions.start') : $t('editor.instructions.next') }}
                    </button>
                </div>
                <div class="w-full justify-center flex mt-5">
                    <span class="font-Inter-Bold text-center hover:underline cursor-pointer" @click="setCookies"
                        >{{ $t('editor.instructions.skip') }}</span
                    >
                </div>
            </div>
        </div>
    </BaseModal>
</template>
<script>
import BaseModal from '@/components/UI/BaseModal.vue';
export default {
    name: 'EditorInstructionsModal',
    components: {
        BaseModal,
    },
    props: {
        steps: {
            type: Array,
            required: true,
            default: () => [],
        },
        cookie: {
            type: String,
            required: true,
        },
        carouselId: {
            type: String,
            required: true,
        },
        startIndex: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            currentStep: 0,
            isOpen: false,
        };
    },
    mounted() {
        if (!this.$cookies.get(this.cookie)) {
            this.isOpen = true;
        }
        setTimeout(() => {
            this.initCarousel();
        }, 250);
    },
    beforeDestroy() {
        this.carousel = null;
    },
    methods: {
        setCookies() {
            this.isOpen = false;
            const options = {
                path: '/',
                maxAge: 60 * 60 * 24 * 30,
            };
            const cookieList = [{ name: this.cookie, value: 'true', opts: options }];

            this.$cookies.setAll(cookieList);
        },
        initCarousel() {
            this.carousel = new this.$swiper(`#${this.carouselId}`, {
                slidesPerView: 1,
                spaceBetween: 0,
                resistance: true,
                resistanceRatio: 0,
                pagination: {
                    el: `#${this.carouselId} .swiper-pagination`,
                    type: 'bullets',
                    clickable: true,
                },
            });

            this.carousel.on('slideChange', () => {
                const activeIndex = this.carousel.activeIndex;
                this.currentStep = activeIndex;
            });
        },
        setSlide() {
            const activeIndex = this.carousel.activeIndex;
            this.currentStep = activeIndex;
            console.log(activeIndex);
        },
        nextSlide() {
            const activeIndex = this.carousel.activeIndex;
            const nextIndex = activeIndex + 1;

            if (nextIndex < this.steps.length) {
                this.carousel.slideTo(nextIndex);
            } else {
                this.isOpen = false;
                this.setCookies();
            }
        },
    },
};
</script>
